export default __webpack_public_path__ + "static/media/LeadPulse.c36ad735812bc1ce8018f42abaeeb870.webp";